module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmSU5fCBc4AMP6lbBP.ca67aa7b.woff2";